module.exports = __webpack_public_path__ + "img/46.4c57a011.jpg";